import { render, staticRenderFns } from "./AudioParser.vue?vue&type=template&id=473ad072"
import script from "./AudioParser.vue?vue&type=script&lang=js"
export * from "./AudioParser.vue?vue&type=script&lang=js"
import style0 from "./AudioParser.vue?vue&type=style&index=0&id=473ad072&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports